const trouble = {
  "1": {
    "name": "车辆转把故障",
    "nickname": "转把故障",
    "content": "无法加速骑行",
    "suggestion": "请支起车辆中撑，复位转把，重新打开电门，若依然提示此故障，请立刻停止用车，联系售后进行检查",
    "resolvion": "联系客服"
  },
  "2": {
    "name": "车辆刹车故障",
    "nickname": "刹车故障",
    "content": "骑行过程中捏刹车无法减速",
    "suggestion": "请支起车辆中撑，复位刹车，重新打开电门，若依然提醒此故障，请停止用车",
    "resolvion": "联系客服"
  },
  "3": {
    "name": "车辆电机故障",
    "nickname": "电机故障",
    "content": "骑行过程中捏刹车无法减速，或拧转把无法加速",
    "suggestion": "请立刻停止用车，关闭车辆总电源开关，联系售后进行检查",
    "resolvion": "联系客服"
  },
  "4": {
    "name": "车辆控制器故障",
    "nickname": "控制器故障",
    "content": "车辆无法锁车，或拧转把无法加速骑行",
    "suggestion": "请立刻停止用车，关闭车辆总电源开关，联系售后进行检查",
    "resolvion": "联系客服"
  },
  "5": {
    "name": "车辆电机霍尔线路异常",
    "nickname": "车辆的电机霍尔线路异常",
    "content": "无法正常骑行，或骑行过程中异常抖动",
    "suggestion": "请立刻停止用车，关闭车辆总电源，联系售后进行检查",
    "resolvion": ""
  },
  "6": {
    "name": "车辆电机相线线路异常",
    "nickname": "车辆的电机相线线路异常",
    "content": "无法正常骑行，或骑行过程中异常抖动",
    "suggestion": "请立刻停止用车，关闭车辆总电源，联系售后进行检查",
    "resolvion": ""
  },
  "8": {
    "name": "车辆控制器供电电压不足",
    "nickname": "控制器欠压警告",
    "content": "车内电池电量过低，或电池额定电压与控制器的工作电压不匹配",
    "suggestion": "1、请先确认电池电量是否过低，电量低请及时充电。$2、若步骤1无异常，确认车内的电池额定电压，确保插入的电池额定电压与控制器工作电压范围相符，若不相符，请立刻将车内电池移除，联系售后进行检查",
    "resolvion": "联系客服"
  },
  "9": {
    "name": "车辆控制器供电电压过高",
    "nickname": "控制器供电电压过高",
    "content": "车内电池的额定电压高于控制器工作电压范围，继续使用电池可能会损坏车辆的电机控制器",
    "suggestion": "请立刻停止用车，确认车内的电池额定电压，确保插入的电池额定电压与控制器工作电压范围相符，若不相符，请立刻将车内电池移除，联系售后进行检查",
    "resolvion": "联系客服"
  },
  "21": {
    "name": "车辆仪表通讯故障",
    "nickname": "仪表通讯故障",
    "content": "仪表上的数据显示不正常，或按左右转向键无法打开转向灯，或远光及近光灯无法打开，无法点亮仪表",
    "suggestion": "为确保您的行车安全，请夜间尽量不要用车，转向时务必注意观察周围行车",
    "resolvion": "联系客服"
  },
  "22": {
    "name": "车辆仪表验证失败",
    "content": "",
    "suggestion": "暂无",
    "resolvion": "暂无"
  },
  "23": {
    "name": "车辆控制器通讯故障",
    "nickname": "控制器通讯故障",
    "content": "骑行速度降限制在10km/h以内",
    "suggestion": "暂无",
    "resolvion": "联系客服"
  },
  "24": {
    "name": "车辆控制器验证失败",
    "nickname": "控制器通讯故障",
    "content": "骑行速度限制在10km/h以内",
    "suggestion": "暂无",
    "resolvion": "联系客服"
  },
  "25": {
    "name": "电池仓1 电池通讯故障",
    "nickname": "电池通讯故障",
    "content": "电池停止给车辆供电",
    "suggestion": "暂无",
    "resolvion": "联系客服"
  },
  "31": {
    "name": "车辆中心控制器通信故障",    
    "content": "行驶速度将限制10km/h以内，或车辆数据传输中断",
    "suggestion": "联系售后工作人员进行检修",
    "resolvion": ""
  },
  "125": {
    "name": "电池仓2 电池通讯故障",
    "nickname": "电池通讯故障",
    "content": "电池停止给车辆供电",
    "suggestion": "暂无",
    "resolvion": "联系客服"
  },
  "50": {
    "name": "车辆日行灯故障",
    "nickname": "日行灯故障",
    "content": "日行灯无法点亮",
    "suggestion": "为确保您的行车安全，请尽量不要在光线不好的环境下行车",
    "resolvion": "联系客服"
  },
  "51": {
    "name": "车辆尾灯故障",
    "nickname": "尾灯故障",
    "content": "车辆尾灯无法点亮",
    "suggestion": "为确保您的行车安全，转向时务必注意观察周围行车",
    "resolvion": "联系客服"
  },
  "52": {
    "name": "车辆左转向灯故障",
    "nickname": "左转向灯故障",
    "content": "左转向灯无法点亮",
    "suggestion": "为确保您的行车安全，转向时务必注意观察周围行车",
    "resolvion": "联系客服"
  },
  "53": {
    "name": "车辆右转向灯故障",
    "nickname": "右转向灯故障",
    "content": "右转向灯无法点亮",
    "suggestion": "为确保您的行车安全，转向时务必注意观察周围行车",
    "resolvion": "联系客服"
  },
  "54": {
    "name": "车辆远光灯故障",
    "nickname": "远光灯故障",
    "content": "远光灯无法点亮",
    "suggestion": "为确保您的行车安全，请尽量不要夜间用车",
    "resolvion": "联系客服"
  },
  "55": {
    "name": "车辆近光灯故障",
    "nickname": "近光灯故障",
    "content": "近光灯无法点亮",
    "suggestion": "为确保您的行车安全，请尽量不要夜间用车",
    "resolvion": "联系客服"
  },
  "44": {
    "name": "电池短路",
    "content": "电池进入自保护状态，停止给车辆供电",
    "suggestion": "请立刻停止用车，并将电池从车内取",
    "resolvion": "联系客服"
  },
  "40": {
    "name": "电池仓1 电池过放",
    "nickname": "电池过放",
    "content": "电池进入自保护状态，停止给车辆供电",
    "suggestion": "请立刻停止用车，给电池充电",
    "resolvion": "请立刻充电，电池过放将影响电池寿命，避免电池处于过放状态"
  },
  "140": {
    "name": "电池仓2 电池过放",
    "nickname": "电池过放",
    "content": "电池进入自保护状态，停止给车辆供电",
    "suggestion": "请立刻停止用车，给电池充电",
    "resolvion": "请立刻充电，电池过放将影响电池寿命，避免电池处于过放状态"
  },
  "41": {
    "name": "电池仓1 电池电压过低",
    "content": "系统检测到您的车辆电池放电电压过低，继续使用车辆会影响电池寿命，车辆的电池电量已耗尽",
    "suggestion": "请立刻停止用车，给车辆充电后，再使用车辆",
    "resolvion": ""
  },
  "141": {
    "name": "电池仓2 电池电压过低",    
    "content": "系统检测到您的车辆电池放电电压过低，继续使用车辆会影响电池寿命，车辆的电池电量已耗尽",
    "suggestion": "请立刻停止用车，给车辆充电后，再使用车辆",
    "resolvion": ""
  },
  "42": {
    "name": "电池仓1 充电电流过大",
    "nickname": "充电电流过大",
    "content": "停止充电，电池进入充电保护状态",
    "suggestion": "立刻拔出充电器",
    "resolvion": "更换与车辆匹配的充电器进行充电，建议您使用厂家标配充电器"
  },
  "142": {
    "name": "电池仓2 充电电流过大",
    "nickname": "充电电流过大",
    "content": "停止充电，电池进入充电保护状态",
    "suggestion": "立刻拔出充电器",
    "resolvion": "更换与车辆匹配的充电器进行充电，建议您使用厂家标配充电器"
  },
  "43": {
    "name": "电池仓1 充电电压过大",
    "nickname": "充电电压过大",
    "content": "停止充电，电池进入充电保护状态",
    "suggestion": "立刻拔出充电器",
    "resolvion": "更换与车辆匹配的充电器进行充电，建议您使用厂家标配充电器"
  },
  "143": {
    "name": "电池仓2 充电电压过大",
    "nickname": "充电电压过大",
    "content": "停止充电，电池进入充电保护状态",
    "suggestion": "立刻拔出充电器",
    "resolvion": "更换与车辆匹配的充电器进行充电，建议您使用厂家标配充电器"
  },
  "44": {
    "name": "电池仓1 电池短路",
    "nickname": "电池短路",
    "content": "电池进入自保护状态，停止给车辆供电",
    "suggestion": "请立刻停止用车，并将电池从车内取",
    "resolvion": "联系客服"
  },
  "144": {
    "name": "电池仓2 电池短路",
    "nickname": "电池短路",
    "content": "电池进入自保护状态，停止给车辆供电",
    "suggestion": "请立刻停止用车，并将电池从车内取",
    "resolvion": "联系客服"
  },
  "45": {
    "name": "电池仓1 充电温度过低",
    "nickname": "充电温度过低",
    "content": "停止充电，电池进入低温保护状态",
    "suggestion": "立刻拔出充电器，将电池移到零度以上的环境",
    "resolvion": "电池在零度以上的环境下恢复温度到正常温度后，再尝试给电池充电，如仍有问题，联系客服"
  },
  "145": {
    "name": "电池仓2 充电温度过低",
    "nickname": "充电温度过低",
    "content": "停止充电，电池进入低温保护状态",
    "suggestion": "立刻拔出充电器，将电池移到零度以上的环境",
    "resolvion": "电池在零度以上的环境下恢复温度到正常温度后，再尝试给电池充电，如仍有问题，联系客服"
  },
  "46": {
    "name": "电池仓1 放电温度过低",
    "nickname": "电池放电温度过低",
    "content": "电池进入低温保护状态，停止给车辆供电",
    "suggestion": "将电池移到零度以上的环境",
    "resolvion": "电池在零度以上的环境下恢复温度到正常温度后，再使用电池，如仍有问题，联系客服"
  },
  "146": {
    "name": "电池仓2 放电温度过低",
    "nickname": "电池放电温度过低",
    "content": "电池进入低温保护状态，停止给车辆供电",
    "suggestion": "将电池移到零度以上的环境",
    "resolvion": "电池在零度以上的环境下恢复温度到正常温度后，再使用电池，如仍有问题，联系客服"
  },
  "47": {
    "name": "电池仓1 充电温度过高",
    "nickname": "充电温度过高",
    "content": "停止充电，电池进入高温保护状态",
    "suggestion": "立刻拔出充电器，将电池移到50度以下的环境",
    "resolvion": "电池在50度以下的环境下恢复正常温度后，再尝试给电池充电，如仍有问题，联系客服"
  },
  "147": {
    "name": "电池仓2 充电温度过高",
    "nickname": "充电温度过高",
    "content": "停止充电，电池进入高温保护状态",
    "suggestion": "立刻拔出充电器，将电池移到50度以下的环境",
    "resolvion": "电池在50度以下的环境下恢复正常温度后，再尝试给电池充电，如仍有问题，联系客服"
  },
  "48": {
    "name": "电池仓1 放电温度过高",
    "nickname": "电池放电温度过高",
    "content": "电池进入高温保护状态，停止给车辆供电",
    "suggestion": "将电池移到50度以下的环境",
    "resolvion": "电池在50度以下的环境下恢复正常温度后，再使用电池，如仍有问题，联系客服"
  },
  "148": {
    "name": "电池仓2 放电温度过高",
    "nickname": "电池放电温度过高",
    "content": "电池进入高温保护状态，停止给车辆供电",
    "suggestion": "将电池移到50度以下的环境",
    "resolvion": "电池在50度以下的环境下恢复正常温度后，再使用电池，如仍有问题，联系客服"
  },
  "100": {
    "name": "机油保养",
    "nickname": "车辆的电机变速箱内机油需要更换保养，不进行机油保养",
    "content": "电机变速箱齿轮损坏，车辆无法正常骑行",
    "suggestion": "暂无",
    "resolvion": ""
  }
}

export default {
  trouble: trouble
}


// WEBPACK FOOTER //
// ./src/assets/js/trouble_blueshark.js